<script>
import axios from "axios";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;

export default {
  setup() {
    const { t } = useI18n();

    // Formfält
    const email = ref("");
    const password = ref("");
    const firstname = ref("");
    const lastname = ref("");
    const companyName = ref("");

    const loading = ref(false);
    const message = ref(null);
    const error = ref(null);

    const addEmployee = async () => {
      error.value = null;
      message.value = null;

      if (
        !email.value ||
        !password.value ||
        !firstname.value ||
        !lastname.value ||
        !companyName.value
      ) {
        error.value = t("errors.fillAllFields");
        return;
      }

      loading.value = true;

      try {
        const res = await axios.post(
          `${apiBaseUrl}/employee`,
          {
            email: email.value,
            password: password.value,
            firstname: firstname.value,
            lastname: lastname.value,
            companyName: companyName.value,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        message.value = res.data.message || t("success.employeeAdded");
        // Rensa formuläret
        email.value = "";
        password.value = "";
        firstname.value = "";
        lastname.value = "";
        companyName.value = "";
      } catch (err) {
        error.value =
          err.response?.data?.error || t("errors.somethingWentWrong");
      } finally {
        loading.value = false;
      }
    };

    return {
      t,
      email,
      password,
      firstname,
      lastname,
      companyName,
      loading,
      message,
      error,
      addEmployee,
    };
  },
};
</script>

<template>
  <div class="mt-16 max-w-md mx-auto space-y-4">
    <h2 class="text-xl font-bold">{{ t("employee.addEmployee") }}</h2>

    <v-text-field
      v-model="firstname"
      :label="t('profile.firstname')"
      type="text"
      color="primary"
    />
    <v-text-field
      v-model="lastname"
      :label="t('profile.lastname')"
      type="text"
      color="primary"
    />
    <v-text-field
      v-model="email"
      :label="t('profile.email')"
      type="email"
      color="primary"
    />
    <v-text-field
      v-model="password"
      :label="t('login.password')"
      type="password"
      color="primary"
    />
    <v-text-field
      v-model="companyName"
      :label="t('company.company')"
      type="text"
      color="primary"
    />

    <v-btn :loading="loading" @click="addEmployee">
      {{ t("employee.addEmployee") }}
    </v-btn>

    <div v-if="message" class="text-green-600 mt-2">{{ message }}</div>
    <div v-if="error" class="text-red-600 mt-2">{{ error }}</div>
  </div>
</template>

<style scoped>
.v-btn {
  transition: all 0.3s ease;
}

.v-btn:hover {
  background-color: #763493 !important;
  color: white !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
